import styled from '@emotion/styled';

export const OlList = styled.ol`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;
